import React from 'react'
import MyPortfolio from '../Components/MyPortfolio/MyPortfolio'


type Props = {}

const Resume = (props: Props) => {


  return (
    <div className='flex w-100% md:mt-6 ml:32 mr:32 mx-auto xl:ml-64 xl:mr-64'>
      <MyPortfolio  />
    </div>
    
  )
}

export default Resume